import { BitmapText, Container } from "pixi.js";
import { getSpineSymbol, SymbolValMap } from "../../config/getSymbol";
import { isSuperQuickBtnOnGlobal, RespinIndex } from "../../config/GlobalVariableConfig";
import { REEL_NUMBERS, SYMBOLS_PER_REEL } from "../../config/reelConfig";
import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponent";
import { DisplayComponent } from "../../core/displays/DisplayComponent";
import { wait } from "../../core/utils";
import { ParallelTask, Task } from "../../core/utils/ParallelTask";
import { SequentialTask } from "../../core/utils/SequentialTask";
import { EventConstants } from "../../gameClientEvents/EventConstants";
import { GameConstants } from "../../gameClientEvents/GameConstants";
import { reelSpinEmitter } from "../../reels/ReelInit";
import { ICoinWin, IFeatureData, IReawaken, IReinfest, IReplicate, RespinObject, spinData } from "../../server/getServerResposesFun";
import { HighlightFramesComponent } from "../highlight/HighlightFramesComponent";
// import { LogoComponent } from "../logo/LogoComponent";
import { sound } from "@pixi/sound";
import { SoundConstants } from "../../gameClientEvents/SoundConstants";
import { MeterComponent } from "../meter/MeterComponent";
import { ReelComponent } from "../reels/ReelsComponent";
import { TransitionComponent } from "../Transition/TransitionComponent";
import { WinMeterComponent } from "../winmeters/WinMeterComponent";
import { RIPTypeTriggerComponent } from "./RIPTypeTriggerComponent";

export class RIPFeatureComponent extends AbstractDisplayComponent {
    private featureData: IFeatureData;
    private delayBetweenCollectActions: number = isSuperQuickBtnOnGlobal ? 100 : 200;
    private delayBetweenReinfest: number = isSuperQuickBtnOnGlobal ? 100 : 200;
    private delayBetweenRevealMultiplier: number = isSuperQuickBtnOnGlobal ? 100 : 200;
    private delayBetweenReawakenMultiplier: number = isSuperQuickBtnOnGlobal ? 200 : 400;
    private trailContainer: Container | null = null;
    public visibilityCheck: Boolean = false;
    public visibilityCheckForCollectMeter: Boolean = true;
    public override init() {

        reelSpinEmitter.on(EventConstants.OVERLAY_SYMBOLS_RESET, this.resetMultipliers, this);
        super.init();
    }

    public override destroy() {
        reelSpinEmitter.off(EventConstants.OVERLAY_SYMBOLS_RESET, this.resetMultipliers, this);
        super.destroy();
    }

    public async startFeature(callback?: () => void): Promise<any> {
        const data: RespinObject = spinData.respins[RespinIndex.value];
        this.featureData = data?.featureData;
        this.visibilityCheck = true;
        if (!this.featureData) {
            console.warn("No featureData found at index", RespinIndex.value);
            callback?.();
            return Promise.resolve();
        }
        let seq = new SequentialTask([
            () => wait(1000),
            () => this.tintSymbols(),
            () => this.showMeterProgress(),
            () => this.transitionBeforeRevealMultipliers(),
            () => this.revealMultipliers(),
            () => this.highlightRIP(),
            () => this.activateFeatures(),
            () => wait(1000),
            () => {
                callback?.();
                return Promise.resolve();
            }
        ]);
        return seq.execute();
    }

    private tintSymbols() {
        let allReelArray = DisplayComponent.get(ReelComponent).getInstance().allReelArray;

        allReelArray.forEach((reelObj, colIndex) => {
            reelObj.symbols.forEach((symbol, rowIndex) => {
                if (symbol.id !== GameConstants.RIP_SYMBOL_ID && symbol.view.visible) {
                    let spineSymbol = DisplayComponent.get(ReelComponent).getInstance().reelSymbols[colIndex][rowIndex];
                    if (spineSymbol) {
                        spineSymbol.tint = 0x555555;
                    }
                }
            });
        });
    }

    private activateSymbols(id: number, callback: () => void) {
        let arr: Task<any>[] = [];
        let allReelArray = DisplayComponent.get(ReelComponent).getInstance().allReelArray;

        allReelArray.forEach((reelObj, colIndex) => {
            reelObj.symbols.forEach((symbol, rowIndex) => {
                if (symbol.id === id && symbol.view.visible) {

                    let spineSymbol = DisplayComponent.get(ReelComponent).getInstance().reelSymbols[colIndex][rowIndex];
                    if (spineSymbol) {
                        spineSymbol.tint = 0xffffff;

                        arr.push(() => new Promise<void>(() => {
                            let listener = {
                                complete: () => {
                                    spineSymbol.state.removeListener(listener);
                                    // callback();
                                }
                            };

                            const symbolCont = DisplayComponent.get(ReelComponent).getInstance().reelSymbolContainers[colIndex][rowIndex];
                            if (symbolCont) {
                                DisplayComponent.get(ReelComponent).getInstance().reelOverlayContainer.addChild(symbolCont);
                            }
                            spineSymbol.state.timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
                            spineSymbol.state.addListener(listener);
                            spineSymbol.state.setAnimation(0, 'active', false).listener = {
                                complete: () => {
                                    spineSymbol.state.setAnimation(0, 'idle', true);
                                    spineSymbol.state.clearListeners();
                                }
                            }
                        }));
                        arr.push(() => new Promise<void>((resolve) => {
                            DisplayComponent.get(HighlightFramesComponent).highlight(colIndex, rowIndex);
                            resolve();
                        }));
                    }
                }
            });
        });
        arr.push(callback);
        let pr = new ParallelTask(arr);
        return pr.execute();
    }

    private async showMeterProgress() {
        let prevFeatureData = spinData.respins[RespinIndex.value - 1]?.featureData;
        let prevRespinType = spinData.respins[RespinIndex.value - 1]?.type;
        let progress = ((prevRespinType === "reveal") ? prevFeatureData.activatedSymbols.progress : ((prevFeatureData.fortuneMeter === 0) ? 10 : prevFeatureData.fortuneMeter));
        let arr: Task<any>[] = [];
        for (let i = 0; i < progress; i++) {
            const validId = (spinData.respins[RespinIndex.value].type === "fs_rip_activated") ? prevFeatureData.activatedSymbols.validSymbols[i] : (i + 1);
            if (validId === undefined) {
                continue;
            }

            arr.push(() => new Promise<void>((resolve) => {
                sound.play(SoundConstants.COIN_FLIP,{volume: 0.5});
                DisplayComponent.get(MeterComponent).activate(validId, resolve);
            }));

            arr.push(() => new Promise<void>((resolve) => {
                this.activateSymbols(validId, resolve);
            }));
            arr.push(() => new Promise<void>((resolve) => {
                DisplayComponent.get(HighlightFramesComponent).hideHighlights();
                resolve();
            }));
            arr.push(() => new Promise<void>(async (resolve) => {
                await wait(1000);
                resolve();
            }));
        }
        let pr = new SequentialTask(arr);
        return pr.execute();
    }

    private async transitionBeforeRevealMultipliers() {
        await new Promise<void>(async (resolve) => {
            DisplayComponent.get(TransitionComponent).play();
            await wait(2000);
            resolve();
        });
    }

    private swapSymbol(reelId: number, colId: number, multiplier: number, visibility: boolean = true, newSymbolId: number = GameConstants.GOLD_COIN) {
        //const symbol = reelObj.symbols[symbolId];
        let symbol = DisplayComponent.get(ReelComponent).getInstance().reelSymbols[reelId][colId];
        if (symbol) {
            const symbolParent = symbol.parent;
            symbol.destroy();
            const newSym = getSpineSymbol(newSymbolId);
            symbolParent.addChildAt(newSym, 0);
            // symbol.parent = newSymbolId;
            symbol = newSym;
            symbol.visible = visibility;
            symbol.tint = 0xffffff;
            symbol.alpha = 1;
            DisplayComponent.get(ReelComponent).getInstance().reelSymbols[reelId][colId] = symbol;
            // symbol.symbolIndex = symbolId;
            if (newSymbolId === GameConstants.GOLD_COIN) {
                newSym.state.setAnimation(0, "multiplier_idle", true);
                DisplayComponent.get(WinMeterComponent).getInstance().revealMultiplier(reelId + "_" + colId, multiplier, symbol);
            }
        }

        // return symbol;
    }

    private revealMultipliers() {
        let newSymbolIds = spinData.respins[RespinIndex.value].featureData.feature.initialMultipliersSymbolIds;
        let arr: Task<any>[] = [];

        for (let i = 0; i < newSymbolIds.length; i++) {
            for (let j = 0; j < newSymbolIds[i].length; j++) {
                if (newSymbolIds[i][j] > 13 && newSymbolIds[i][j] !== GameConstants.RIP_SYMBOL_ID) {
                    const multiplier = SymbolValMap[newSymbolIds[i][j]];
                    DisplayComponent.get(WinMeterComponent).getInstance().setupMeter(i + "_" + j);
                    // DisplayComponent.get(LogoComponent).setLogoPositionDuringRIPFeature();
                    this.revealMultiplierSym([i, j], multiplier, arr)
                }
            }
        }

        let pr = new ParallelTask(arr);
        return pr.execute({ stagger: this.delayBetweenRevealMultiplier, waitStrategy: "all" });
    }

    private revealMultiplierSym(symbol: number[], multiplier: number, arr: Task<any>[]) {
        console.log("mult " + multiplier);

        let sym = DisplayComponent.get(ReelComponent).getInstance().reelSymbols[symbol[0]][symbol[1]];

        let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;

        arr.push(() => new Promise<void>((resolve) => {
            let listener = {
                event: (_entry: any, event: any) => {
                    if (event.data.name === "multiplier") {
                        DisplayComponent.get(WinMeterComponent).getInstance().setupMeter(symbol[0] + "_" + symbol[1], multiplier);
                        DisplayComponent.get(WinMeterComponent).getInstance().revealMultiplier(symbol[0] + "_" + symbol[1], multiplier, sym);
                    }
                },
                complete: () => {
                    resolve();
                    sym.state.removeListener(listener);
                    sym.state.timeScale = timeScale;
                    sym.state.setAnimation(0, "multiplier_idle", true);
                }
            };


            sym.tint = 0xffffff;
            sym.state.addListener(listener);
            sym.state.timeScale = timeScale;
            sym.state.setAnimation(0, "multiplier_reveal", false).listener = {
                complete: () => {
                    sym.state.removeListener(listener);
                    this.swapSymbol(symbol[0], symbol[1], multiplier, true);
                    resolve();
                }
            }

        }));
    }

    private highlightRIP() {
        const pos = this.featureData.feature.ripPos;
        if (pos.length === 0) {
            return new Promise<void>((resolve) => {
                resolve();
            });
        }
        const featureName = this.featureData.featureName;
        const sym = DisplayComponent.get(ReelComponent).getInstance().reelSymbols[pos[0][0]][pos[0][1]];
        let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
        const regex = new RegExp(Object.keys(GameConstants.FEATURE_NAME_MAP).join("|"), "g");

        const symbolCont = DisplayComponent.get(ReelComponent).getInstance().reelSymbolContainers[pos[0][0]][pos[0][1]];
        if (symbolCont) {
            DisplayComponent.get(ReelComponent).getInstance().reelOverlayContainer.addChild(symbolCont);
        }
        const featureType = featureName
            .replace(regex, (matched) => GameConstants.FEATURE_NAME_MAP[matched])
            .replace(/(?<!^)([A-Z])/g, "_$1")
            .toLowerCase();

            return new Promise<void>((resolve) => {
                let listener = {
                    complete: () => {
                        resolve();
                        sym.state.removeListener(listener);
                        let ripSymbolNewId = featureName.replace(/([a-z])([A-Z])/g, '$1_$2').toUpperCase() + "_SYMBOL_ID";
                        this.swapSymbol(pos[0][0], pos[0][1], -1, true, GameConstants.RIP_SYMBOL_MAP[ripSymbolNewId]);
                    }
                };
                
                sym.state.addListener(listener);
                sym.state.timeScale = timeScale;
                sym.state.setAnimation(0, featureType, false);
                console.log("RIP sound triggered");
                sound.play(SoundConstants.RIP_REVEAL, { volume : 1, singleInstance: true  });
            });
        }
        
        private async activateFeatures() {
        let tasks: Task<any>[] = [];
        this.featureData.feature.data.forEach((feature) => {
            switch (feature.name) { // replcate , reinfest , reawaken, coinWin
                case "replicate":
                    tasks.push(() => this.replicate(feature as IReplicate));
                    break;
                case "reinfest":
                    tasks.push(() => this.reinfest(feature as IReinfest));
                    break;
                case "reawaken":
                    tasks.push(() => this.reawaken(feature as IReawaken));
                    break;
                case "coinWin":
                    tasks.push(() => this.collectCoins(feature as ICoinWin));
                    break;
            }
        });

        const seq = new SequentialTask(tasks);
        await seq.execute();
    }

    private replicate(feature: IReplicate) {
        let tasks: Task<any>[] = [];
        tasks.push(() => {
            const pos = this.featureData.feature.ripPos?.[0];
            const sym = pos
                ? DisplayComponent.get(ReelComponent).getInstance().reelSymbols[pos[0]][pos[1]]
                : null;
            return sym
                ? DisplayComponent.get(WinMeterComponent).getInstance().playSkullFeatureAnimation(sym, this.featureData, feature.name)
                : Promise.resolve();
        });

        tasks.push(() => new Promise<void>(async (resolve) => {
            await wait(1000);
            sound.play(SoundConstants.REAWAKEN, { volume: 0.5 });
            resolve();
        }));

        tasks.push(() => new Promise<void>((resolve) => {
            DisplayComponent.get(RIPTypeTriggerComponent).play(feature.name, resolve);
        }));

        tasks.push(() => new Promise<void>(async (resolve) => {
            this.replicateMultipliers(feature);
            await wait(1000);
            resolve();
        }));

        let pr = new SequentialTask(tasks);
        return pr.execute();
    }

    private replicateMultipliers(feature: IReplicate) {
        for (let i = 0; i < feature.postMult.length; i++) {
            for (let j = 0; j < feature.postMult[i].length; j++) {
                if (feature.postMult[i][j] > 0) {
                    const multiplier = feature.postMult[i][j];
                    const sym = DisplayComponent.get(ReelComponent).getInstance().reelSymbols[i][j];
                    if (sym) {
                        let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;

                        let listener = {
                            complete: async () => {
                                sym.state.removeListener(listener);
                                sym.state.timeScale = timeScale;
                                sym.state.setAnimation(0, "multiplier_idle", true);
                                //DisplayComponent.get(WinMeterComponent).getInstance().updateMultiplier(multiplier, sym);
                                const txt = sym.getSlotObject("multiplier") as BitmapText;
                                if (txt) {
                                    DisplayComponent.get(WinMeterComponent).getInstance().doubleMultiplierAnimation(txt, multiplier);
                                }
                            }
                        };

                        sym.state.addListener(listener);
                        sym.state.timeScale = timeScale;
                        sym.state.setAnimation(0, "multiplier_impact", false);
                    }
                }
            }
        }
    }

    private reinfest(feature: IReinfest) {
        let tasks: Task<any>[] = [];
        tasks.push(() => {
            const pos = this.featureData.feature.ripPos?.[0];
            const sym = pos
                ? DisplayComponent.get(ReelComponent).getInstance().reelSymbols[pos[0]][pos[1]]
                : null;
            return sym
                ? DisplayComponent.get(WinMeterComponent).getInstance().playSkullFeatureAnimation(sym, this.featureData, feature.name)
                : Promise.resolve();
        });

        tasks.push(() => new Promise<void>(async (resolve) => {
            await wait(1000);
            sound.play(SoundConstants.REAWAKEN, { volume: 0.5 });
            resolve();
        }));

        tasks.push(() => new Promise<void>((resolve) => {
            DisplayComponent.get(RIPTypeTriggerComponent).play(feature.name, resolve);
        }));

        tasks.push(() => new Promise<void>(async (resolve) => {
            await this.reinfestMultipliers(feature);
            // DisplayComponent.get(HighlightFramesComponent).hideHighlights();
            resolve();
        }));

        tasks.push(() => new Promise<void>(async (resolve) => {
            await wait(1000);
            resolve();
        }));

        let pr = new SequentialTask(tasks);
        return pr.execute();

    }

    private async reinfestMultipliers(feature: IReinfest) {

        let pickedSymbols = feature.pickedPositions;
        const trailContainer = this.multiplierTrailContainer();

        let trailTasks: Task<any>[] = [];

        for (let i = 0; i < pickedSymbols.length; i++) {
            let reel = pickedSymbols[i][0];
            let row = pickedSymbols[i][1];
            const multiplier = feature.multipliers[i];
            const targetSymbol = DisplayComponent.get(ReelComponent).getInstance().reelSymbols[reel][row];
            const targetSymbolText = targetSymbol?.getSlotObject("multiplier") as BitmapText;

            const trailIndex = (reel * SYMBOLS_PER_REEL) + row + 1;
            const trailAnim = `trail${trailIndex}`;

            trailTasks.push(() =>
                DisplayComponent.get(WinMeterComponent).getInstance().playReinfestTrail(
                    trailContainer,
                    trailAnim,
                    multiplier,
                    targetSymbol,
                    targetSymbolText,
                    isSuperQuickBtnOnGlobal ? 2 : 1
                )
            );
            trailTasks.push(async() =>
            {
                await wait(500);
                await sound.play(SoundConstants.COIN_FLIP, { volume: 0.7 });
            }
            );
        }

        await new ParallelTask(trailTasks).execute({ stagger: this.delayBetweenReinfest, waitStrategy: "all" });

        let spiralTasks: Task<any>[] = [];

        for (let i = 0; i < pickedSymbols.length; i++) {
            let targetSymbol = DisplayComponent.get(ReelComponent).getInstance().reelSymbols[pickedSymbols[i][0]][pickedSymbols[i][1]];
            let targetSymbolText = targetSymbol.getSlotObject("multiplier") as BitmapText;
            // const multiplier = feature.multipliers[i];

            if (targetSymbolText) {

                spiralTasks.push(async () => {
                    let targetMult = feature.postMult[pickedSymbols[i][0]][pickedSymbols[i][1]];

                    await new Promise<void>((resolve) => {
                        const listener = {
                            complete: () => {
                                targetSymbol.state.removeListener(listener);
                                resolve();
                            }
                        };

                        targetSymbol.state.addListener(listener);
                        targetSymbol.state.timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
                        targetSymbol.state.setAnimation(0, "multiplier_impact", false);
                    });

                    targetSymbol.state.timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
                    targetSymbol.state.setAnimation(0, "multiplier_idle", true);

                    await wait(500);

                    await DisplayComponent.get(WinMeterComponent).getInstance().travelMultiplier(targetSymbol, targetMult);

                    DisplayComponent.get(WinMeterComponent).getInstance().updateMultiplier(targetMult, targetSymbol);
                });
            }
        }

        if (spiralTasks.length === 0) {
            return new Promise<void>((resolve) => resolve());
        }

        await new ParallelTask(spiralTasks).execute({ stagger: this.delayBetweenReinfest, waitStrategy: "all" });
    }

    private multiplierTrailContainer(): Container {
        if (!this.trailContainer) {
            this.trailContainer = new Container();
            this.trailContainer.label = "reinfest_trails";
            this.trailContainer.position.set(450, 450);
        }

        const overlay = DisplayComponent.get(ReelComponent).getInstance().reelOverlayContainer;

        overlay.addChild(this.trailContainer);

        this.trailContainer.visible = true;
        return this.trailContainer;
    }

    private async collectCoins(feature: ICoinWin) {
        let travelTasks: Task<any>[] = [];
        const pos = this.featureData.feature.ripPos;
        if (this.visibilityCheckForCollectMeter) {
            DisplayComponent.get(WinMeterComponent).getInstance().showCollectMeter();
            this.visibilityCheckForCollectMeter = false;
        }
        await new Promise(resolve => setTimeout(resolve, 1000));

        for (let i = 0; i < feature.positions.length; i++) {
            let [reelIndx, symbolIndx] = feature.positions[i];
            if (reelIndx === pos[0][0] && symbolIndx === pos[0][1]) continue;

            const srcSymbol = DisplayComponent.get(ReelComponent).getInstance().reelSymbols[reelIndx][symbolIndx];
            let sMultiplier: BitmapText | null = null;
            try {
                sMultiplier = srcSymbol.getSlotObject("multiplier") as BitmapText;
            } catch (e) { continue; }

            if (!sMultiplier) continue;

            travelTasks.push(async () => {
                await new Promise<void>(res => {
                    DisplayComponent.get(WinMeterComponent).getInstance()
                        .addMultiplierTravelAnimation_Collect(sMultiplier, res);
                    srcSymbol.tint = 0x555555;
                    srcSymbol.state.setAnimation(0, "multiplier_idle", false);
                    srcSymbol.state.timeScale = 0;
                });
                sound.play(SoundConstants.COIN_FLIP, { volume: 0.5 });
            });
        }

        if (travelTasks.length > 0) {
            const masterTravel = new ParallelTask(travelTasks);
            await masterTravel.execute({ stagger: this.delayBetweenCollectActions, waitStrategy: "all" });
        }
        return new Promise<void>((resolve) => resolve());
    }

    private reawaken(feature: IReawaken) {
        let tasks: Task<any>[] = [];
        tasks.push(() => {
            const pos = this.featureData.feature.ripPos?.[0];
            const sym = pos
                ? DisplayComponent.get(ReelComponent).getInstance().reelSymbols[pos[0]][pos[1]]
                : null;
            return sym
                ? DisplayComponent.get(WinMeterComponent).getInstance().playSkullFeatureAnimation(sym, this.featureData, feature.name)
                : Promise.resolve();
        });

        tasks.push(() => new Promise<void>(async (resolve) => {
            await wait(1000);
            sound.play(SoundConstants.REAWAKEN, { volume: 0.5 });
            resolve();
        }));

        tasks.push(() => new Promise<void>((resolve) => {
            DisplayComponent.get(RIPTypeTriggerComponent).play(feature.name, resolve);
        }));

        tasks.push(() => new Promise<void>(async (resolve) => {
            await this.reawakenMultipliers(feature);
            resolve();
        }));

        tasks.push(() => new Promise<void>(async (resolve) => {
            await wait(1000);
            resolve();
        }));

        let pr = new SequentialTask(tasks);
        return pr.execute();
    }

    public async tintRemovalAfterRoundCompleted() {

        for (let i = 0; i < REEL_NUMBERS; i++) {
            for (let j = 0; j < SYMBOLS_PER_REEL; j++) {
                const sym = DisplayComponent.get(ReelComponent).getInstance().reelSymbols[i][j];
                sym.tint = 0xffffff;
            }
        }
    }

    private async reawakenMultipliers(feature: IReawaken) {

        let newSymbolIds = feature.multipliers;
        let arr: Task<any>[] = [];

        for (let i = 0; i < newSymbolIds.length; i++) {
            for (let j = 0; j < newSymbolIds[i].length; j++) {
                if (newSymbolIds[i][j] > 13 && newSymbolIds[i][j] !== GameConstants.RIP_SYMBOL_ID) {
                    const multiplier = SymbolValMap[newSymbolIds[i][j]];
                    const sym = DisplayComponent.get(ReelComponent).getInstance().reelSymbols[i][j];
                    arr.push(() => {
                        const listner = {
                            event: async (_entry: any, event: any) => {
                                if (event.data.name === "reveal") {
                                    sym.state.setAnimation(0, "multiplier_idle", true);
                                    sym.tint = 0xffffff;
                                }
                            },
                            complete: () => {
                                sym.state.removeListener(listner);
                            }
                        };
                        sym.state.setAnimation(0, "multiplier_reawkean", false);
                        sym.state.addListener(listner);
                        const bitmapText = sym.getSlotObject("multiplier") as BitmapText;
                        sym.state.timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
                        if (bitmapText) {
                            DisplayComponent.get(WinMeterComponent).getInstance().reawakenMorph(bitmapText, multiplier);
                        }
                    });
                }
            }
        }

        let pr = new ParallelTask(arr);
        await pr.execute({ stagger: this.delayBetweenReawakenMultiplier, waitStrategy: "all" });
        return new Promise<void>((resolve) => resolve());
    }


    private resetMultipliers() {
        DisplayComponent.get(WinMeterComponent).getInstance().resetMultipliers();
        if (this.trailContainer) {
            const removed = this.trailContainer.removeChildren();
            removed.forEach(child => child.destroy());
            this.trailContainer.visible = false;
            this.trailContainer.destroy();
            this.trailContainer = null;
        }
    }
}
